export default __webpack_public_path__ + "static/media/oldfog5.526c87a6.png";